@import '../../utils/control-density.css';
@import '../../utils/shimmer.css';

:host {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 0;
  vertical-align: middle;
  --ds-skeleton-base: var(--color-foreground-quaternary);
  --ds-shimmer: var(--color-shimmer-shimmer);
}

.skeleton__shape {
  --ds-shimmer-surface-base: var(--ds-skeleton-base);

  display: block;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  background-color: var(--ds-skeleton-base);
  border-radius: var(--dimension-radius-025);
}

/* ── Background context ────────────────────────────────────────────────── */

:host(.skeleton--background-medium) {
  --ds-skeleton-base: var(--color-foreground-on-medium-background-quaternary);
  --ds-shimmer: var(--color-shimmer-shimmer-on-medium-background);
}

:host(.skeleton--background-bold) {
  --ds-skeleton-base: var(--color-foreground-on-bold-background-quaternary);
  --ds-shimmer: var(--color-shimmer-shimmer-on-bold-background);
}

:host(.skeleton--background-strong) {
  --ds-skeleton-base: var(--color-foreground-on-strong-background-quaternary);
  --ds-shimmer: var(--color-shimmer-shimmer-on-strong-background);
}

:host(.skeleton--background-translucent) {
  --ds-skeleton-base: var(--color-translucent-foreground-quaternary);
  --ds-shimmer: var(--color-translucent-shimmer);
}

:host(.skeleton--background-inverted) {
  --ds-skeleton-base: var(--color-inverted-foreground-quaternary);
  --ds-shimmer: var(--color-inverted-shimmer);
}

:host(.skeleton--background-media) {
  --ds-skeleton-base: var(--color-media-foreground-quaternary);
  --ds-shimmer: var(--color-media-shimmer);
}

:host(.skeleton--background-always-dark) {
  --ds-skeleton-base: var(--color-always-dark-foreground-quaternary);
  --ds-shimmer: var(--color-always-dark-shimmer);
}

:host(.skeleton--background-navigation) {
  --ds-skeleton-base: var(--color-navigation-foreground-quaternary);
  --ds-shimmer: var(--color-navigation-shimmer);
}

/* ── Text ──────────────────────────────────────────────────────────────── */

:host(.skeleton--text) {
  width: 100%;
  height: var(--ds-skeleton-canvas-size);
  padding-block: 0;
}

:host(.skeleton--text) .skeleton__shape {
  height: 75%;
}

:host(.skeleton--text-text-display-medium) { --ds-skeleton-canvas-size: var(--typography-lineheight-3xl); }
:host(.skeleton--text-text-display-small)  { --ds-skeleton-canvas-size: var(--typography-lineheight-2xl); }
:host(.skeleton--text-text-title-large)    { --ds-skeleton-canvas-size: var(--typography-lineheight-xl); }
:host(.skeleton--text-text-title-medium),
:host(.skeleton--text-text-body-large)     { --ds-skeleton-canvas-size: var(--typography-lineheight-lg); }
:host(.skeleton--text-text-title-small),
:host(.skeleton--text-text-body-medium)    { --ds-skeleton-canvas-size: var(--typography-lineheight-md); }
:host(.skeleton--text-text-body-small)     { --ds-skeleton-canvas-size: var(--typography-lineheight-sm); }
:host(.skeleton--text-text-caption)        { --ds-skeleton-canvas-size: var(--typography-lineheight-xs); }

/* ── Icon ──────────────────────────────────────────────────────────────── */

:host(.skeleton--icon) {
  width: var(--ds-skeleton-canvas-size);
  height: var(--ds-skeleton-canvas-size);
  padding: 0;
}

:host(.skeleton--icon) .skeleton__shape {
  width: 75%;
  height: 75%;
}

:host(.skeleton--icon.skeleton--rounded) .skeleton__shape {
  border-radius: var(--dimension-radius-half);
}

:host(.skeleton--icon-xs)  { --ds-skeleton-canvas-size: var(--dimension-iconography-xs); }
:host(.skeleton--icon-sm)  { --ds-skeleton-canvas-size: var(--dimension-iconography-sm); }
:host(.skeleton--icon-md)  { --ds-skeleton-canvas-size: var(--dimension-iconography-md); }
:host(.skeleton--icon-lg)  { --ds-skeleton-canvas-size: var(--dimension-iconography-lg); }
:host(.skeleton--icon-xl)  { --ds-skeleton-canvas-size: var(--dimension-iconography-xl); }
:host(.skeleton--icon-2xl) { --ds-skeleton-canvas-size: var(--dimension-iconography-2xl); }
:host(.skeleton--icon-3xl) { --ds-skeleton-canvas-size: var(--dimension-iconography-3xl); }

/* ── Control ───────────────────────────────────────────────────────────── */

:host(.skeleton--control) {
  width: 100%;
  height: var(--ds-control-height);
}

:host(.skeleton--control) .skeleton__shape {
  border-radius: var(--ds-control-radius, var(--dimension-radius-025));
}

:host(.skeleton--control.skeleton--rounded) .skeleton__shape {
  border-radius: var(--dimension-radius-half);
}

@media (forced-colors: active) {
  .skeleton__shape {
    background-color: var(--ds-forced-color-disabled);
  }
}
